/* eslint-disable */

import axios from 'axios';
import { invalidateSendCatalog } from '@/utils/sendPanelCatalog';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

/**
 * Escape a value for safe interpolation into a SQL string literal. The
 * backend's `/runquery` endpoint takes raw SQL with no parameter binding, so
 * the frontend must do its own escaping on any user-supplied value that ends
 * up in these queries (siteID, tag name, search terms, etc.).
 *
 * Handles the cases we actually need:
 *   - null / undefined → NULL
 *   - string: wrap in single quotes, escape embedded quotes and backslashes
 *
 * Do NOT use for integers or identifiers. Only for string literals.
 */
function sqlEscapeString(v) {
    if (v === null || v === undefined) return 'NULL';
    const s = String(v);
    // Escape: backslash first, then single quote, then null byte and CR/LF just in case
    const escaped = s
        .replace(/\\/g, '\\\\')
        .replace(/'/g, "\\'")
        .replace(/\0/g, '\\0')
        .replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r');
    return `'${escaped}'`;
}

export default {

    namespaced: true,
    state: {
        wikipages: [],
    },
    mutations: {
        setWikiPages(state, pages) {
            state.wikipages = pages;
        }
    },
    getters: {
        wikiPages: state => state.wikipages
    },
    actions: {
     
        async createWiki({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/wiki', payload, { crossdomain: true });
                invalidateSendCatalog('wiki');
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                dispatch('alert/setLoaded', true, {root: true});                
                /*                
                dispatch('alert/setMessage', 'Wiki page created successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                */
                
                return response;
            } catch(err) {                
                dispatch('alert/setErrored', true, {root: true});

                /*
                console.log('Error creating a wiki page:', err);                
                dispatch('alert/setMessage', err, {root: true});
                */
                throw err;
            }
        },

        async updateWiki({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.put(`/wiki/${payload.WikiPageID}`, payload, { crossdomain: true });
                invalidateSendCatalog('wiki');
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                /*
                dispatch('alert/setMessage', 'Wiki page updated successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                */
                return response;
            } catch(err) {
                dispatch('alert/setErrored', true, {root: true});

                /*
                console.log('Error updating a wiki page:', err);                
                dispatch('alert/setMessage', err, {root: true});
                */
                throw err;
            }
        },

        async checkWikiReferences({commit, dispatch}, payload) {
            try {
                let response = await axios.get(`/wiki/${payload.WikiPageID}/references`, { crossdomain: true });
                return response.data;
            } catch (err) {
                console.log('Error checking wiki references:', err);
                return { references: [] };
            }
        },

        async deleteWiki({commit, dispatch}, payload) {
            try {
                //dispatch('alert/setLoading', true, {root: true});
                let response = await axios.delete(`/wiki/${payload.WikiPageID}`, payload, { crossdomain: true });
                invalidateSendCatalog('wiki');
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                //dispatch('alert/setLoaded', true, {root: true});
                /*
                dispatch('alert/setMessage', 'Wiki page deleted successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
                */
                return response;
            } catch(err) {
                /*
                dispatch('alert/setErrored', true, {root: true});                
                console.log('Error deleting a wiki page', err);                
                dispatch('alert/setMessage', err, {root: true});
                */
                throw err;
            }
        },

        async getWikiPages({commit, dispatch}, payload) {
            // payload: { siteID, [tags], [searchTerm], [silent] }
            //   silent: optional boolean (absent => exactly the old behaviour). true skips the error
            //     alert/* dispatches AND the `setWikiPages` commit — state.wiki.wikipages is read by
            //     WorkflowBuilder / WikiWidget, which must not see a tag-filtered list from a background
            //     read. A failure still resolves undefined. The Send popup's catalog prefetch / refresh.
            const silent = !!(payload && payload.silent);
            try {
                //dispatch('alert/setLoading', true, {root: true});

                // All user-supplied values routed through sqlEscapeString because
                // /runquery is a raw-SQL endpoint with no parameter binding.
                const siteID = sqlEscapeString(payload.siteID);

                let query = `
                    SELECT a.WikiPageID, a.Name, a.CreatedByEmployeeID, a.Content, a.CreatedAt, a.UpdatedAt, a.AllEmployeesCanSee,
                    a.IsEmailTemplate, a.IsSmsTemplate, a.IsPublic, a.EnableSpanishTranslation, a.EnabledLanguages, a.SendgridTemplateID,
                    a.EmailSubject,
                    IFNULL(a.IsPinned, 0) as IsPinned,
                    group_concat(c.Name) as Tags FROM
                    teamio.wikipages a
                    LEFT JOIN teamio.wikitags b INNER JOIN teamio.tags c on b.TagID = c.TagID
                    ON a.WikiPageID = b.WikiPageID
                    where a.SiteID = ${siteID}`;

                if(payload.searchTerm) {
                    // LIKE wildcards added AFTER escaping to prevent quote injection
                    const searchPattern = sqlEscapeString(`%${payload.searchTerm}%`);
                    query = query + ` and a.Name like ${searchPattern}`;
                }

                query = query + `
                    group by a.WikiPageID, a.Name, a.Content`;

                if(payload.tags) {
                    // Use FIND_IN_SET for exact tag matching instead of LIKE '%%'.
                    // Previously "sms-template" would spuriously match a hypothetical
                    // "sms-template-archived"; FIND_IN_SET splits group_concat on
                    // commas and does exact equality.
                    const tagName = sqlEscapeString(payload.tags);
                    query = query + ` having FIND_IN_SET(${tagName}, group_concat(c.Name)) > 0`;
                }

                query = query + `
                    order by a.UpdatedAt desc
                    ;

                    SELECT st.TagID, t.Name as Tag FROM
                    teamio.sitetags st, teamio.tags t
                    where st.TagID = t.TagID
                    and st.SiteID = ${siteID};

                    select distinct TagID, Name as Tag from
                    teamio.tags;

                    select FormIDForWeb, Name
                    from teamio.forms
                    where SiteID=${siteID};
                    `;

                let queryToSend = {
                    sqlQuery: query
                }
        
                let response = await axios.post('/runquery', queryToSend, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Store wiki pages in the state
                if (!silent && response.data && response.data.length > 0) {
                    commit('setWikiPages', response.data[0] || []);
                }
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                //dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting wiki pages:', err);
                if (!silent) dispatch('alert/setErrored', true, {root: true});
                if (!silent) dispatch('alert/setMessage', err, {root: true});
            }
        },

        async getWikiPage({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                
                let query = {
                    sqlQuery: `
                        SELECT a.WikiPageID, a.Name, a.Content, a.AllEmployeesCanSee, a.IsEmailTemplate, a.IsSmsTemplate, a.IsPublic, a.EnableSpanishTranslation, a.EnabledLanguages, a.SendgridTemplateID,
                        group_concat(c.Name) as Tags FROM
                        teamio.wikipages a
                        LEFT JOIN teamio.wikitags b INNER JOIN teamio.tags c on b.TagID = c.TagID
                        ON a.WikiPageID = b.WikiPageID
                        where a.WikiPageID='${payload.wikiPageID}'
                        group by a.WikiPageID, a.Name, a.Content;

                        SELECT st.TagID, t.Name as Tag FROM 
                        teamio.sitetags st, teamio.tags t
                        where st.TagID = t.TagID
                        and st.SiteID = '${payload.siteID}';
                    `
                }
        
                let response = await axios.post('/runquery', query, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                
                // Simulating async call to external service
                //await new Promise(resolve => setTimeout(resolve, 2000));
                //throw new Error("Something bad happened");
                
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting a wiki page:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async getSiteTags({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                const siteID = sqlEscapeString(payload.siteID);
                let query = {
                    sqlQuery: `
                    SELECT DISTINCT st.TagID, t.Name as Tag FROM
                    teamio.sitetags st, teamio.tags t
                    where st.TagID = t.TagID
                    and st.SiteID = ${siteID};
                    `
                }
                let response = await axios.post('/runquery', query, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error creating a wiki page:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        // ============================================================================
        // TRANSLATION ACTIONS - Spanish language support
        // ============================================================================

        /**
         * Get translation for a wiki page
         * @param {string} payload.wikiPageID - Wiki page ID
         * @param {string} payload.languageCode - Language code (default: 'spa')
         */
        async getWikiTranslation({commit, dispatch}, payload) {
            try {
                const languageCode = payload.languageCode || 'spa';
                let response = await axios.get(`/wiki/${payload.wikiPageID}/translation/${languageCode}`, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error getting wiki translation:', err);
                // Don't set global error - translation might just not exist
                return null;
            }
        },

        /**
         * Save manual translation edit
         * @param {string} payload.wikiPageID - Wiki page ID
         * @param {string} payload.languageCode - Language code (default: 'spa')
         * @param {string} payload.Content - Translated content (EditorJS JSON)
         */
        async saveManualTranslation({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                const languageCode = payload.languageCode || 'spa';
                let response = await axios.put(
                    `/wiki/${payload.wikiPageID}/translation/${languageCode}`, 
                    { Content: payload.Content },
                    { crossdomain: true }
                );
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error saving manual translation:', err);
                dispatch('alert/setErrored', true, {root: true});
                throw err;
            }
        },

        /**
         * Force re-translate a wiki page (overwrites manual edits)
         * @param {string} payload.wikiPageID - Wiki page ID
         * @param {string} payload.languageCode - Language code (default: 'spa')
         */
        async translateWikiNow({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                const languageCode = payload.languageCode || 'spa';
                let response = await axios.post(
                    `/wiki/${payload.wikiPageID}/translate`,
                    { languageCode },
                    { crossdomain: true }
                );
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error translating wiki:', err);
                dispatch('alert/setErrored', true, {root: true});
                throw err;
            }
        },

        // ============================================================================
        // PUBLIC WIKI ACTIONS - Public sharing support
        // ============================================================================

        /**
         * Get a public shareable URL for a wiki page
         * @param {string} payload.siteID - Site ID
         * @param {string} payload.wikiPageID - Wiki page ID
         * @returns {string} Short URL (e.g., /l/xyz789a)
         */
        async getWikiUrl({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading2', true, {root: true});
                let response = await axios.post('/get-wiki-url', payload, { crossdomain: true });
                dispatch('alert/setLoaded2', true, {root: true});
                return response;
            } catch(err) {
                console.log('Error getting wiki url:', err);
                dispatch('alert/setErrored2', true, {root: true});
                dispatch('alert/setMessage2', err, {root: true});
                throw err;
            }
        },

        /**
         * Get a public wiki page (no authentication required)
         * @param {string} payload.wikiPageID - Wiki page ID
         * @param {string} payload.lang - Language preference ('en' or 'es')
         * @returns {object} Wiki page data (if public), with Spanish translation if available and requested
         */
        async getPublicWiki({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                // Include language param if Spanish is requested
                const langParam = payload.lang === 'es' ? '?lang=es' : '';
                let response = await axios.get(`/public/wiki/${payload.wikiPageID}${langParam}`, { crossdomain: true });
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting public wiki:', err);
                dispatch('alert/setErrored', true, {root: true});
                throw err;
            }
        },

        // ============================================================================
        // WIKI PIN FEATURE
        // ============================================================================

        /**
         * Toggle pin status for a wiki page
         * @param {string} payload.wikiPageID - Wiki page ID
         * @param {string} payload.siteID - Site ID
         * @param {boolean} payload.isPinned - New pin status
         */
        async togglePinWiki({dispatch}, payload) {
            try {
                let response = await axios.post('/toggle-pin-wiki', payload, { crossdomain: true });
                return response;
            } catch (err) {
                console.log('Error toggling pin wiki:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
                throw err;
            }
        },

        // ============================================================================
        // WIKI IMPORT — Document parsing
        // ============================================================================

        /**
         * Parse an uploaded document into structured templates via AI
         * @param {string} payload.file - Base64-encoded file content
         * @param {string} payload.fileType - File type ('docx')
         * @returns {object} { templates, variableMappings, hardcodedValues }
         */
        async parseDocument({dispatch}, payload) {
            try {
                let response = await axios.post('/wiki/parse-document', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.error('Error parsing document:', err);
                throw err;
            }
        },

        /**
         * Start bulk document parsing (knowledge base articles)
         * @param {object} payload - { files: [{ name, data }], siteID }
         * @returns {object} { jobId, status: 'processing' }
         */
        async parseDocuments({dispatch}, payload) {
            try {
                let response = await axios.post('/wiki/parse-documents', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.error('Error starting bulk document parse:', err);
                throw err;
            }
        },

        async getParseResult({dispatch}, jobId) {
            try {
                let response = await axios.get(`/wiki/parse-document/${jobId}`, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.error('Error getting parse result:', err);
                throw err;
            }
        },

        async getPresignedUploadUrl({ dispatch }, payload) {
            try {
                const response = await axios.post('/wiki/get-upload-url', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.error('Error getting presigned upload URL:', err);
                throw err;
            }
        },

        async saveUploadMeta({ dispatch }, payload) {
            try {
                const response = await axios.post('/wiki/save-upload-meta', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.error('Error saving upload metadata:', err);
                throw err;
            }
        },
    }
}